import React from 'react';
import SearchBanner from 'src/page-components/404/SearchBanner';
import * as Sentry from '@sentry/nextjs';
import logger from 'src/utils/logger';
import Button, { ButtonColor, ButtonSize } from '../Button';
import Constraints from '../Constraints/Constraints';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorLog: null, errorInfo: null };
  }

  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logger.log('ErrorBoundary', { error, errorInfo });
    this.setState({ errorLog: error, errorInfo });
    if (process.env.NEXT_PUBLIC_ENV === 'prod') {
      Sentry.captureException(error);
    }
  }

  render() {
    // Check if the error is thrown
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (this.state.hasError) {
      return (
        <Constraints className="flex flex-col">
          <SearchBanner searchInputRef={null} errorCode="---" />
          <div className="flex flex-col space-y-3 m-3 p-2 border border-periwinkleGray">
            <p className="fs-header5-bold">Лог помилки</p>
            <p>
              <span className="fs-body-bold">Error message:</span>{' '}
              {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.state.errorLog?.message
              }
            </p>
            <p>
              <span className="fs-body-bold break-all whitespace-normal">
                Error stack:
              </span>{' '}
              {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.state.errorLog?.stack
              }
            </p>
            <p>
              <span className="fs-body-bold break-all whitespace-normal">
                Error info:
              </span>{' '}
              {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                JSON.stringify(this.state.errorInfo)
              }
            </p>
          </div>
          <div className="flex self-center pb-2">
            <Button
              className="uppercase mt-5"
              type="submit"
              onClick={() => this.setState({ hasError: false })}
              color={ButtonColor.blue}
              size={ButtonSize.lg}
            >
              Спробувати ще?
            </Button>
          </div>
        </Constraints>
      );
    }

    // Return children components in case of no error
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    return this.props.children;
  }
}

export default ErrorBoundary;
